import { toast } from "react-toastify";
import axiosConfig from "../axiosConfig.js";

class VisitService {
    getVisits = async (accessToken) => {
        try {
            const response = await axiosConfig.get("scheduling/getVisits");
            return response;
        } catch (error) {
            const errorMessage = error?.message || "No Visits"; // Fallback message
            // Show the error message as a toast notification
            toast.error(errorMessage);
            // Re-throw the error for further handling if needed
            throw new Error(error);
        }
    };
    getVisitDetails = async (Id, accessToken) => {
        try {
            const response = await axiosConfig.get(`scheduling/v2/getVisitDetails/${Id}`);
            return response;
        } catch (error) {
            const errorMessage = error?.message || "No Visit Details"; // Fallback message
            // Show the error message as a toast notification
            toast.error(errorMessage);
            // Re-throw the error for further handling if needed
            throw new Error(error);
        }
    };
    
    reScheduleVisit = async (requestBody, accessToken) => {
        try {
            const response = await axiosConfig.patch("scheduling/reScheduleVisit", requestBody);
            return response;

        } catch (error) {
            const errorMessage = error.message || "An error occurred while booking your visit. Please try again."; // Fallback message
            // Show the error message as a toast notification
            toast.error(errorMessage);
            // Re-throw the error for further handling if needed
            throw new Error(error);
        }
    };
    cancelVisit = async (requestBody, accessToken) => {
        try {
            const response = await axiosConfig.delete(`scheduling/cancelVisit/${requestBody}`);
            return response;

        } catch (error) {
            const errorMessage = error.message || "An error occurred while booking your visit. Please try again."; // Fallback message
            // Show the error message as a toast notification
            toast.error(errorMessage);
            // Re-throw the error for further handling if needed
            throw new Error(error);
        }
    };
    
}

const instance = new VisitService();

export default instance;
